
import {
  Component, PropSync, Mixins, Watch,
} from 'vue-property-decorator';
import focusMixin from '@/features/common/mixins/focusMixin';
import InputDatePicker from '@/features/common/components/InputDatePicker.vue';
import InputTimePicker from '@/features/common/components/InputTimePicker.vue';
import { InProgress, SignatureType } from '../../types';

@Component({
  components: {
    InputDatePicker,
    InputTimePicker,
  },
})
export default class AdditionalReturnOptionsModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  private isSubmitting = false;

  private isPriceChanged = false;

  private returnOption : '' | 'standard' | 'label-free' | 'label-free-box-free' = '';

  get inProgressData(): InProgress {
    return this.$store.getters.getInProgress;
  }

  get priceChange(): { text: string; classes: string } {
    const { signatureOptions } = this.inProgressData;

    if (signatureOptions === SignatureType.AdultSignatureRequired) {
      return {
        text: this.$t('shipment.yourResults.additionalReturnOptions.amounts.withAdultSignature') as string,
        classes: 'text-error',
      };
    }

    if (!signatureOptions || signatureOptions === SignatureType.None) {
      return {
        text: this.$t('shipment.yourResults.additionalReturnOptions.amounts.withNoSignature') as string,
        classes: '',
      };
    }

    return {
      text: '',
      classes: '',
    };
  }

  get isNextButtonEnabled(): boolean {
    return this.returnOption !== '' && !this.isSubmitting;
  }

  get isLimitationsVisible(): boolean {
    return this.returnOption === 'label-free' || this.returnOption === 'label-free-box-free';
  }

  @Watch('syncedShow', { immediate: true })
  private onSyncedShowChange(newValue: boolean) {
    if (!newValue) return;

    this.isSubmitting = false;

    const { isBoxFree, isLabelFree, isReturnShipment } = this.inProgressData || {};

    if (isBoxFree) {
      this.returnOption = 'label-free-box-free';
    } else if (isLabelFree) {
      this.returnOption = 'label-free';
    } else if (isReturnShipment) {
      this.returnOption = 'standard';
    } else {
      this.returnOption = '';
    }
  }

  private async submit() {
    const { signatureOptions: existingSignature, packages } = this.inProgressData || {};

    const targetSignature = this.returnOption === 'standard' ? existingSignature : SignatureType.SignatureRequired;

    const payload: InProgress = {
      ...this.inProgressData,
      signatureOptions: targetSignature,
      packages: packages.map((pkg) => ({
        ...pkg,
        signatureOptions: targetSignature || SignatureType.None,
      })),
      isReturnShipment: this.returnOption === 'standard'
        || this.returnOption === 'label-free'
        || this.returnOption === 'label-free-box-free',
      isLabelFree: this.returnOption === 'label-free' || this.returnOption === 'label-free-box-free',
      isBoxFree: this.returnOption === 'label-free-box-free',
    };

    this.$store.commit('setInProgress', payload);

    this.isSubmitting = true;
    await this.$store.dispatch('syncInProgressData');
    this.isSubmitting = false;

    this.$emit('next', this.isPriceChanged);
    this.syncedShow = false;
  }
}
